<template>
    <div class="container-fluid">
      <div
        class="d-flex flex-wrap flex-column flex-sm-row mb-3 justify-content-between"
      >
        <div class="">
          <div class="d-flex align-items-center">
            <div class="s-32 font-weight-bold text-head text-black">
                Manage Department
            </div>
          </div>
          <BackRoute />
        </div>
        <div class="d-flex flex-column flex-sm-row link">
          <router-link class="" to="">
            <el-button
              :color="primarycolor"
              class="header-btn w-100 mt-3 mt-sm-0"
              round
            >
            Add Department
            </el-button></router-link
          >
        </div>
      </div>
      <div class="row">
        <div class="container-fluid">
          <div
            class="col-md-12 px-0 py-5 mt-4 bg-light2 border-radius-8 border border-radius"
          >
            <div class="col-md-12">
              <TableNoExport2
                :data="filteredData"
                :headers="ManageUsersHeaders"
                :textHead="textHead"
                @update:searchText="handleSearchTextUpdate"
                :checkMultipleItem="false"
                :filterItem="false"
                @checkedrow="handleSelectionChange"
              >
                <template v-slot:id="{ item }">
                  <div class="c-pointer fw-400 s-10">
                    {{ item.id }}
                  </div>
                </template>
                <template v-slot:users="{ item }">
                  <div class="c-pointer fw-400 s-10">
                    {{ item.users }}
                  </div>
                </template>
                <template v-slot:dateCreated="{ item }">
                  <div class="c-pointer fw-400 s-10">
                    {{ item.dateCreated }}
                  </div>
                </template>
                <template v-slot:action="">
                  <el-dropdown trigger="click">
                    <el-icon>
                      <MoreFilled />
                    </el-icon>
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item>
                          <div class="text-color">Delete</div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </template>
              </TableNoExport2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script setup>
  import { ref, inject, computed } from "vue";
  import router from "../../router";
  import BackRoute from "../../components/backroute/BackRoute.vue";
  import TableNoExport2 from "../../components/table/TableNoExport2.vue";
  
  const primarycolor = inject("primarycolor");
  
  const goBack = () => {
    router.go(-1);
  };
  
  const searchText = ref("");
  const textHead = ref("Manage Department");
  
  const ManageUsersHeaders = ref([
    { name: "ID", value: "id" },
    { name: "USERS", value: "users" },
    { name: "DATE CREATED", value: "dateCreated" },
    { name: "ACTION", value: "action" },
  ]);
  
  const manageUsersData = ref([
    {
      id: "AB-547",
      users: "Vehicle",
      dateCreated: "Toyota Camry",
    },
    {
      id: "AB-547",
      users: "Vehicle",
      dateCreated: "Toyota Camry",
    },
    {
      id: "AB-547",
      users: "Vehicle",
      dateCreated: "Toyota Camry",
    },
    {
      id: "AB-547",
      users: "Vehicle",
      dateCreated: "Toyota Camry",
    },
    {
      id: "AB-547",
      users: "Vehicle",
      dateCreated: "Toyota Camry",
    },
    {
      id: "AB-547",
      users: "Vehicle",
      dateCreated: "Toyota Camry",
    },
  ]);
  const handleSearchTextUpdate = (newValue) => {
    searchText.value = newValue;
  };
  const filteredData = computed(() => {
    if (!searchText.value.trim()) {
      return manageUsersData.value;
    }
    return manageUsersData.value.filter((item) =>
      Object.values(item)
        .join(" ")
        .toLowerCase()
        .includes(searchText.value.toLowerCase())
    );
  });
  </script>
  